type AuthPageHeaderProps = {
  id?: string
  title: string
  subtitle?: string
}

/**
 * Cabeçalho das telas de autenticação.
 *
 * Generaliza o que existia só no acesso: título entre divisórias e subtítulo
 * centralizado. As sub-rotas traziam, cada uma, o cabeçalho do próprio
 * formulário legado — com outra hierarquia, outro peso e outro contraste —, e o
 * participante trocava de linguagem visual a cada passo do fluxo.
 */
export function AuthPageHeader({ id, title, subtitle }: AuthPageHeaderProps) {
  return (
    <div className="mb-4 short:mb-2.5">
      <div className="flex items-center gap-2.5">
        <span className="h-px flex-1 bg-gray-200" aria-hidden />
        <h2 id={id} className="shrink-0 text-base font-extrabold text-gray-900">
          {title}
        </h2>
        <span className="h-px flex-1 bg-gray-200" aria-hidden />
      </div>
      {subtitle ? (
        <p className="mt-1 text-center text-xs font-semibold text-gray-700 short:hidden">
          {subtitle}
        </p>
      ) : null}
    </div>
  )
}
